import { render, staticRenderFns } from "./PricingNew.vue?vue&type=template&id=48d7edb6&"
import script from "./PricingNew.vue?vue&type=script&lang=js&"
export * from "./PricingNew.vue?vue&type=script&lang=js&"
import style0 from "./PricingNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports